import { FieldErrorProps, RJSFSchema, StrictRJSFSchema } from '@rjsf/utils';

import { ErrorText } from 'design-system/components/FormControl';

/** The `FieldErrorTemplate` component renders the errors local to the particular field
 *
 * @param props - The `FieldErrorProps` for the errors being rendered
 */
export function FieldErrorTemplate<T = any, S extends StrictRJSFSchema = RJSFSchema, F = any>(
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  props: FieldErrorProps<T, S, F>,
) {
  const { errors = [] } = props;
  if (errors.length === 0) {
    return null;
  }

  return (
    <>
      {errors
        .filter((elem) => !!elem)
        .map((error, index: number) => {
          return <ErrorText key={index}>{error}</ErrorText>;
        })}
    </>
  );
}
